<template>
  <div class="page-container">
    <div class="icon-content">
      <img class="icon-tip" :src="require('@/assets/2026/ClaimCoupon.png')" />

      <div class="center-area">
        <div class="amount-row">
          <span class="currency" v-if="discountType !== 3">¥</span>
          <span class="number">{{ displayAmount }}</span>
          <span class="currency" v-if="discountType === 3" style="font-size: 40px; margin-left: 5px;">
            折
          </span>
        </div>
        <div class="condition-tag" v-if="conditionText">{{ conditionText }}</div>
      </div>

      <div v-if="buttonTitle" class="action-btn-wrapper" :class="{ disabled: isBtnDisabled }" @click="handleAction">
        <img class="btn-bg" :src="require('@/assets/2026/commit.png')" />
        <span class="btn-text">{{ buttonTitle }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getCouponLinkUrl, claimCouponAction } from "@/api/user";

export default {
  data() {
    return {
      displayAmount: "0", // 折扣值
      conditionText: "",
      buttonTitle: "",
      discountType: 0, // 优惠方式：1=立减, 2=满减, 3=折扣
      // 回显按钮/标识：1-可领取，2-已领取，3-不可领取
      currentStatus: 1,

      type: 0,//1-客服渠道优惠券链接，2-推广活动主动领取优惠券链接
      number: "",//流水号

    };
  },

  computed: {
    isBtnDisabled() {
      return this.currentStatus === 3 || this.currentStatus === 2;
    },
  },

  mounted() {


    let result = this.$route.query.o || '';

    if (result) {
      
    //1-客服渠道优惠券链接，2-推广活动主动领取优惠券链接
    let firstPart = result.charAt(0);
    this.type = parseInt(firstPart);

    ///流水号
    let secondPart = result.slice(1);
    this.number = secondPart;

    this.getCouponLinkAction();
    }

  },

  methods: {
    handleAction() {

      if (this.buttonTitle == "立即领取") {

        Toast.loading({
          message: "领取中...",
          forbidClick: true,
        });

        const params = {
          t: parseInt(this.type),
          o: this.number
        };

        claimCouponAction(params).then(() => {

          this.buttonTitle = "去使用";
          Toast.success("领取成功！");
        });
      } else if (this.buttonTitle == "去使用") {
        this.uni.navigateTo("/home/updateBuy?isShowOther=1&isenterAuth=0");
      } else {

      }


    },

    getCouponLinkAction() {
      const params = {
        t: parseInt(this.type),
        o: this.number
      };

      getCouponLinkUrl(params).then((res) => {

        // 优惠方式：1=立减, 2=满减, 3=折扣
        this.discountType = parseInt(res.discountType);

        switch (this.discountType) {
          case 1: // Fixed Reduction (立减)
            this.displayAmount = res.fixedAmount; // 立减金额（仅当 discountType=1 时有效）
            this.conditionText = "无门槛立减";
            break;
          case 2: // Full Reduction (满减)
            this.displayAmount = res.fullReduceAmount;
            this.conditionText = `满${res.fullReduceThreshold}可用`; // 满减金额（满X减Y中的Y，仅当 discountType=2 时有效）
            break;
          case 3: // Discount (折扣)
            this.displayAmount = res.discountValue; // 满额折扣门槛（满X元，仅当 discountType=3 时有效）
            this.conditionText = `满${res.discountThreshold}可用`;
            break;
          default:

        }

        // 回显按钮/标识：1-可领取，2-已领取，3-不可领取
        this.currentStatus = parseInt(res.echoButton);

        switch (res.echoButton) {
          case 1:
            this.buttonTitle = "立即领取";
            break;
          case 2:
            this.buttonTitle = "已领取";
            break;
          case 3:
            this.buttonTitle = "不可领取";
            break;
          default:
            this.buttonTitle = "不可领取";
            break;
        }

      });
    },
  },
};
</script>

<style lang="less" scoped>
.page-container {
  width: 100%;
  background-color: #f5f5f5;
}

.icon-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  .icon-tip {
    width: 100%;
    height: auto;
    display: block;
  }

  .center-area {
    position: absolute;
    top: 46%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 100%;
    z-index: 10;

    .amount-row {
      color: #e62e2e;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: baseline;
      line-height: 1;
      margin-bottom: 16px;

      .currency {
        font-size: 44px;
        margin-right: 5px;
      }

      .number {
        font-size: 132px;
      }
    }

    .condition-tag {
      display: inline-block;
      background: #fdcaa0;
      color: #ff0403;
      font-size: 28px;
      padding: 12px 28px;
      border-radius: 50px;
      font-weight: bold;
      letter-spacing: 4px;
    }
  }

  .action-btn-wrapper {
    position: absolute;
    bottom: 20%;
    left: 50%;
    transform: translateX(-50%);
    width: 70%;
    z-index: 20;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    &.disabled {
      opacity: 0.6;
      pointer-events: none;
    }

    .btn-bg {
      width: 100%;
      height: auto;
      display: block;
    }

    .btn-text {
      position: absolute;
      left: 50%;
      top: 45%;
      transform: translate(-50%, -50%);
      font-size: 44px;
      color: #db2302;
      font-weight: bold;
      letter-spacing: 5px;
      white-space: nowrap;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>